import React from 'react';

import {NotepadAvatar} from 'ccm/art/MedicalIcons';
import InfoCard from './InfoCard';

export default function ProgressNotesCard(props) {
    return (
        <InfoCard
            color='blue'
            Avatar={NotepadAvatar}
            title='Progress Notes'
            {...props}
        ></InfoCard>
    );
}
